// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"748":"ca8166e8","787":"13a97525"}[chunkId] + ".chunk.js";
};